import { Storage } from '@/modules/plugins/storage'
import Vue from 'vue'
import { Restaurant } from '@/api'

const state = {
    delivery: false,
    currency: {},
    restaurant: Storage.getItem('orderRestaurant') || {},
    address: Storage.getItem('address') || {},
    //geohash: localStorage.getItem('geohash') || undefined,
    time: Storage.getItem('time', false),
    groupSettings: Storage.getItem('groupSettings') || {},
    asap: true,
}

const mutations = {
    SET_DELIVERY(state, data) {
        state.delivery = data
    },
    SET_RESTAURANT(state, payload) {
        state.restaurant = payload
    },
    SET_ADDRESS(state, payload) {
        state.address = payload
        state.geohash = payload.geohash
    },
    SET_TIME(state, payload) {
        state.time = payload
    },
    SET_CALCULATION(state, payload) {
        state.calculation = payload
    },
    SET_ASAP(state, payload) {
        state.asap = payload
    },
    RESET_TIME(state) {
        state.time = undefined
    },
    RESET_RESTAURANT(state) {
        state.restaurant = {}
    },
    RESET_ADDRESS(state) {
        state.address = {}
    },
    RESET_GROUP(state) {
        state.groupSettings = {}
    },
    SET_GROUP(state, payload) {
        state.groupSettings = payload
    },
}

const actions = {
    setDelivery({ commit }, data) {
        commit('SET_DELIVERY', data)
    },
    setTime({ commit, state }, payload) {
        commit('SET_TIME', payload)
        Storage.setItem('time', state.time)
    },
    setRestaurant({ commit, state }, payload) {
        commit('SET_RESTAURANT', payload)
        Storage.setItem('orderRestaurant', state.restaurant)
    },
    resetRestaurant({ commit }) {
        commit('RESET_RESTAURANT')
        Storage.removeItem('orderRestaurant')
    },
    setAddress({ commit, state }, payload) {
        payload = payload._model ? payload._model : payload
        commit('SET_ADDRESS', { ...payload })
        Storage.setItem('address', { ...state.address })
        Vue.prototype.$cart.address = { ...state.address }
        Vue.prototype.$user.setCurrentAddress(payload.id)
    },
    resetAddress({ commit }) {
        commit('RESET_ADDRESS')
        Storage.removeItem('address')
        Vue.prototype.$cart.resetAddress()
        Vue.prototype.$user.setCurrentAddress()
    },
    resetTime({ commit }) {
        commit('RESET_TIME')
        Storage.removeItem('time')
    },
    setAsap({ commit }, payload) {
        commit('SET_ASAP', payload)
    },
    setGroup({ commit, state }, payload) {
        commit('SET_GROUP', payload)
        Storage.setItem('groupSettings', state.groupSettings)
    },
    resetGroup({ commit }) {
        commit('RESET_GROUP')
        Storage.removeItem('groupSettings')
    },
}

const getters = {
    isDelivery: (state) => state.delivery,
    restaurant: (state) => new Restaurant(state.restaurant),
    address: (state) => state.address,
    //geohash: state => state.geohash,
    time: (state) => (state.time ? Number(state.time) : undefined),
    asap: (state) => state.asap,
    groupSettings: (state) => state.groupSettings,
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
